import { render, staticRenderFns } from "./hero-image.vue?vue&type=template&id=b138fdd8&scoped=true&"
import script from "./hero-image.vue?vue&type=script&lang=js&"
export * from "./hero-image.vue?vue&type=script&lang=js&"
import style0 from "./hero-image.vue?vue&type=style&index=0&id=b138fdd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b138fdd8",
  null
  
)

export default component.exports